import React, { useState } from 'react';
import GazeControl from "../GazeControl";
import ToHomeButton from "../buttons/ToHomeButton";
import ModelSelecter, { MODEL_SELECT_OPTIONS } from "../buttons/ModelSelecter";
import ColoredPartSelecter from "../buttons/ColoredPartSelecter";
import { matchGazePositions } from "../buttons/MatchGazeButton";

// 視点変更ガイドは一致視点（matchGazePositions）が定義されたモデルのみ扱えるため、
// デモの選択肢もそこに絞る（他モデルを選べると一致視点なしでアニメが壊れる）
const GAZE_DEMO_OPTIONS = MODEL_SELECT_OPTIONS.filter((o) => o.value in matchGazePositions);

function Demo3() {
  const [errorGlbPath, setErrorGlbPath] = useState('model1');
  // 部品の着色はプルダウン選択（selectedPart）→「着色を決定」で確定（appliedPart）の2段階。
  // 確定値を GazeControl の key に含めて再マウントし、頂点カラーの反映を確実にする
  // （演習フローでは部品選択が前ステップで確定しているため、途中変更の再着色経路がない）。
  const [selectedPart, setSelectedPart] = useState('');
  const [appliedPart, setAppliedPart] = useState('');

  // モデルを切り替えたら部品選択もリセット（皿グラス系⇔立方体系で部品体系が異なる）
  const handleModelChange = (glbPath) => {
    setSelectedPart('');
    setAppliedPart('');
    setErrorGlbPath(glbPath);
  };

  return (
    <div className="page">
      <h1 className="heading-hero mb-6">視点変更ガイドデモ</h1>

      <div className="row-center mb-4">
        <ModelSelecter
          errorGlbPath={errorGlbPath}
          setErrorGlbPath={handleModelChange}
          options={GAZE_DEMO_OPTIONS}
        />
        <ColoredPartSelecter
          selectedPart={selectedPart}
          setSelectedPart={setSelectedPart}
          onApply={() => setAppliedPart(selectedPart)}
          isCube={errorGlbPath.startsWith('cube')}
          attentionOnApply={false}
        />
      </div>

      {/* onComplete を渡さない＝デモ表示。説明シートは演習と同じように出るが、
          【決定】を押しても何も起こらず実験ログも送らない。
          number も渡さない＝「問N」見出しなし（ページ側の見出しだけにする） */}
      <GazeControl
        key={`${errorGlbPath}:${appliedPart}`}
        selectedPart={appliedPart}
        errorGlbPath={errorGlbPath}
      />

      <div className="row-center mt-6">
        <ToHomeButton buttonText="Home画面に戻る" />
      </div>
    </div>
  );
}

export default Demo3;
